import A11yButtonToggle from 'a11y/classes/A11yButtonToggle'

export default class PlaceFilter extends A11yButtonToggle {
  constructor(element, mapElement) {
    super(element)

    this.mapElement = mapElement

    if (this.element.getAttribute('aria-pressed') === 'false') {
      const customEvent = this.createEvent({
        type: this.element.dataset.type,
        active: false,
      })

      this.dispatchEvent(customEvent)
    }
  }

  createEvent(detail) {
    return new CustomEvent('filterChange', { detail })
  }

  handleClick(event) {
    super.handleClick(event)

    const customEvent = this.createEvent({
      type: event.currentTarget.dataset.type,
      active: event.currentTarget.getAttribute('aria-pressed'),
    })

    this.mapElement.dispatchEvent(customEvent)
  }

  dispatchEvent(event) {
    this.mapElement.dispatchEvent(event)
  }
}
